// DTOs and enums for the nostro-operations feature.
// Ported from:
//   src/app/model/enum/nostro-operation-type.ts
//   src/app/model/enum/nostro-operations-order-type-enum.enum.ts
//   src/app/model/enum/nostro-operations-type-enum.enum.ts
//   src/app/model/enum/add-withdraw-funds-status-enum.enum.ts
//   src/app/model/enum/payment-intermediaries-status-enum.enum.ts
//   and associated model classes.

// ---- Enums ---------------------------------------------------------------

export enum NostroOperationType {
  ADD_FUNDS = 'add_funds',
  WITHDRAW_FUNDS = 'withdraw_funds',
  ADJUST = 'adjust',
}

export enum NostroOperationsOrderTypeEnum {
  ALL = 'All',
  PURCHASE_ORDER = 'Purchase Order',
  WITHDRAWAL_ORDER = 'Withdrawal Order',
}

// Angular source has two identical enums (nostro-operations-order-type-enum and
// nostro-operations-type-enum). Share one definition here.
export { NostroOperationsOrderTypeEnum as NostroOperationTypeEnum };

export enum AddWithdrawFundsStatusEnum {
  ALL = 'ALL',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
  PROCESSED = 'PROCESSED',
}

// PaymentIntermediariesStatusEnum / PaymentIntermediary types are now sourced from
// '@/types/payment-intermediary' (canonical). Re-exported aliases live below.
import type { PaymentIntermediary } from './payment-intermediary';
export { PaymentIntermediaryStatusFilter as PaymentIntermediariesStatusEnum } from './payment-intermediary';

// ---- DTOs ----------------------------------------------------------------

export interface ExternalServicesOperationsFields {
  UUID?: string;
  'Diool Tracking ID'?: string;
  Date?: string;
  'Diool User ID'?: string;
  'Diool User Name'?: string;
  Status?: string;
  'Order Type'?: string;
  'External Service'?: string;
  'Provider Diool Code'?: string;
  'Amount Requested'?: number;
  Fees?: number;
  'Amount Paid'?: number;
  'Amount to Pay'?: number;
  'Payment Method'?: string;
  'Payment Intermediary'?: string[];
  'Payment Account Number'?: string[];
  'External Payment Reference'?: string;
  Notes?: string;
  'Provider Account Code'?: string;
  'Provider Account Name'?: string;
  'Provider Account Type'?: string;
}

export interface ExternalServicesOperationsRecord {
  id: string;
  fields: ExternalServicesOperationsFields;
  createdTime?: string;
}

/** @deprecated Use `PaymentIntermediary` from '@/types/payment-intermediary' instead. */
export type PaymentIntermediariesRecord = PaymentIntermediary;

export interface StatsAddFundsResponse {
  pending: number;
  canceled: number;
  processed: number;
  total: number;
}

export interface StatsAddWithdrawFundsResponse {
  addFunds?: StatsAddFundsResponse;
  withdrawFunds?: StatsAddFundsResponse;
  bankTransfer?: StatsAddFundsResponse;
  withdrawRevenue?: StatsAddFundsResponse;
}

export interface NostroAccount {
  accountName: string;
  counterValue: unknown;
  crCredit: number;
  daCredit: number;
  fxValue: unknown;
}

export interface NostroAccountAdjustRequest {
  accountId: number;
  amount: number;
  idPaymentIntermediary: string;
}

export interface ConfirmNostroOperationRequest {
  recordId: string;
  uuid: string;
  idPaymentIntermediary: string;
  userAccount?: string;
  amountPaid?: number;
  serviceReference?: string;
  externalReference?: string;
  notes?: string;
  /** Enum key e.g. 'PURCHASE_ORDER' | 'WITHDRAWAL_ORDER' — mirrors Angular's getEnumKeyByValue output */
  operationType?: string;
}

export interface AirtableFindNostroOperationsRecordsRequest {
  /** Enum key sent to API: 'PURCHASE_ORDER' | 'WITHDRAWAL_ORDER' | 'ALL' */
  orderType: string;
  status: AddWithdrawFundsStatusEnum;
}
